/* eslint-disable */
export default {
  _title_0: 'title_0',
}